import { APP_ROUTES } from '../types/global/routes.types';

/**
 * Creator Dashboard visibility config.
 * Toggle sidebar routes, dashboard tabs, and the default home route here.
 * Set any value to `true` to show, `false` to hide.
 */

/* ── Sidebar menu items (top "MENU" section) ──────────────── */
/** Campaigns & Audme use this config only (not API feature flags) so they show on first paint. */
export const CREATOR_SIDEBAR_MENU_VISIBILITY = {
    Feed: false,
    Campaigns: true,
    Discover: true,
    Sandbox: true,
    Audme: false,
    'Live Events': false,
} as const;

/* ── Sidebar "PERSONAL" section items ─────────────────────── */
export const CREATOR_SIDEBAR_PERSONAL_VISIBILITY = {
    Profile: false,
    Dashboard: true,
    /** Shown only when user has jury role — see EsSidebarDataSignedIn */
    'Jury duty': true,
    Projects: true,
    Talents: false,
} as const;

/* ── Dashboard tabs ───────────────────────────────────────── */
export const CREATOR_DASHBOARD_TAB_VISIBILITY = {
    Overview: true,
    'Bookmarked Campaigns': false,
    'Contest Submissions': true,
    Auditions: false,
    Tickets: false,
    'Audition Applications': true,
    Campaigns: false,
    Events: false,
} as const;

/* ── Dashboard Overview widgets (rectangular cards + chart row) ─ */
export const CREATOR_DASHBOARD_OVERVIEW_VISIBILITY = {
    totalSalesCard: false,
    salesTrendChart: false,
} as const;

/* ── Default home route (where / and /api redirect to) ────── */
export const CREATOR_HOME_ROUTE = APP_ROUTES.ESDISCOVERY;
